import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ProductTreeActions } from "../actions/product-tree.actions";
import { ProductTreeState } from "../models/mp-common/product-tree.state";

const initialState: ProductTreeState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(ProductTreeActions.productTree.success, (state, action) => ({
		..._.omit(state, "error"),
		...action.state
	})),
	on(ProductTreeActions.productTree.fail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	}))
);

export function productTreeReducer(
	state: ProductTreeState | undefined,
	action: Action
): ProductTreeState {
	return reducer(state, action);
}
